import React, { useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import Client from './components/Client';
import CommercialAnalysisWorkspace from './components/biReports/CommercialAnalysisWorkspace';
import { latestCompletedSunday } from './components/biReports/SalesTrends';

export default function RapCommercialAnalysis({ onReady, mobileLayout = false }) {
  const [client] = useState(() => new Client('none'));
  const latestDate = latestCompletedSunday();

  useEffect(() => {
    if (onReady) onReady();
  }, [onReady]);

  return <Box component="main" sx={{
    flexGrow: 1,
    width: { xs: 'calc(100vw - 8px)', sm: '100%' },
    maxWidth: { xs: 'calc(100vw - 8px)', sm: '100%' },
    ml: { xs: 'calc(50% - 50vw + 4px)', sm: 0 },
    overflowX: 'hidden',
    height: '100%',
    pt: mobileLayout ? 0 : { xs: 0.75, sm: 1.5, md: 3 },
    pb: mobileLayout ? 0 : { xs: 1, sm: 2, md: 3 },
    px: { xs: 0.5, sm: 1, md: 2 },
    boxSizing: 'border-box',
  }}>
    <Paper elevation={0} sx={{
      width: '100%',
      boxSizing: 'border-box',
      height: '100%',
      minHeight: 0,
      borderRadius: mobileLayout ? { xs: '14px 14px 0 0', sm: '16px 16px 0 0' } : { xs: '14px', sm: '16px' },
      border: '1px solid rgba(15, 23, 42, 0.06)',
      boxShadow: '0 4px 14px rgba(15, 23, 42, 0.08)',
      textAlign: 'left',
      overflow: 'hidden',
    }}>
      <CommercialAnalysisWorkspace client={client} latestDate={latestDate} embedded />
    </Paper>
  </Box>;
}
